var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M127.9,10C62.9,10,10,62.9,10,128.1C10,193.1,62.9,246,127.9,246c65.2,0,118.1-52.9,118.1-117.9C246,62.9,193.1,10,127.9,10z M127.9,239.4c-61.4,0-111.4-50-111.4-111.4c0-61.5,50-111.5,111.4-111.5c61.5,0,111.5,50,111.5,111.5C239.4,189.5,189.5,239.4,127.9,239.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M177,79c-4.1-4.1-9.3-6-14.6-6c-5.4,0-10.6,2-14.7,6L73,153.8V183h29.3l64.3-64.3l10.5-10.5C185,100.1,185,87.1,177,79z M99.5,176.5H79.5v-19.9l57.7-57.7l19.9,19.9L99.5,176.5z M172.4,103.5l-10.5,10.6L142,94.2l10.5-10.6c2.6-2.6,6.2-4.1,10-4.1c3.7,0,7.2,1.4,10,4.1C177.9,89.1,177.9,98,172.4,103.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.4c0745a7f39c63174a9d5bef5e446fee.svg";
export { ForwardRef as ReactComponent };